import { u as useCurrentComponentId } from "./useCurrentComponentId-01b0304d.mjs";
const TELEPORT_FROM_ATTR = "data-va-teleported-from";
const TELEPORT_ATTR = "data-va-teleported";
const findTeleportedFrom = (el) => {
  if (!el) {
    return null;
  }
  const teleportId = el.getAttribute(TELEPORT_ATTR);
  if (teleportId === null) {
    return findTeleportedFrom(el.parentElement);
  }
  return document.querySelector(`[${TELEPORT_FROM_ATTR}="${teleportId}"]`);
};
const useTeleported = () => {
  const componentId = useCurrentComponentId();
  return {
    teleportFromAttrs: {
      [TELEPORT_FROM_ATTR]: componentId
    },
    teleportedAttrs: {
      [TELEPORT_ATTR]: componentId
    },
    findTeleportedFrom
  };
};
export {
  findTeleportedFrom as f,
  useTeleported as u
};
//# sourceMappingURL=useTeleported-c9f0a2cb.mjs.map
